import { Navigate, Outlet, RouteObject } from 'react-router-dom';
import { ContentProgressIndicator } from 'shared/layout/ContentProgressIndicator';
import { useHasOnboardingPackets } from 'shared/modules/onboarding-packets/data/OnboardingPacketsAPI';
import { OnboardingPacketsWebViewPage } from './OnboardingPacketsWebViewPage';

export const onboardingPacketsRoutes: RouteObject[] = [
  {
    path: 'onboarding-packets',
    element: <OnboardingPacketsWebViewOutlet />,
    children: [
      {
        children: [
          {
            path: 'not-submitted',
            element: <OnboardingPacketsWebViewPage status="pending" />,
          },
          {
            path: 'pending',
            element: <OnboardingPacketsWebViewPage status="submitted" />,
          },
          {
            path: 'accepted',
            element: <OnboardingPacketsWebViewPage status="accepted" />,
          },
          {
            path: 'not-accepted',
            element: <OnboardingPacketsWebViewPage status="not_accepted" />,
          },
          {
            index: true,
            element: <OnboardingPacketsWebViewPage />,
          },
        ],
      },
    ],
  },
];

function OnboardingPacketsWebViewOutlet() {
  const { hasOnboardingPackets, isLoading } = useHasOnboardingPackets();

  if (isLoading) {
    return <ContentProgressIndicator />;
  }

  if (!hasOnboardingPackets) {
    return <Navigate to="/profile" replace={true} />;
  }

  return <Outlet />;
}
